import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../../src/types";
import { languages, checkLineCount, combineErrors, signatureInfo, size, getContentField } from "./shared";

const griefText = 'In diesen schweren Stunden besteht unser Trost oft nur darin, liebevoll zu schweigen und schweigend mitzuteilen.'


export const griefTemplateData: CustomerTemplate = {
    key: 'grief',
            name: {
                de: 'Trauer-Karte',
                en: 'Card-of-condolence'
            },
            ...size,
            languages,
            signatureInfo,
            templateData: [
                {
                    key: 'headlineTop',
                    name: {
                        en: 'Headline Top',
                        de: 'Überschrift obere Zeile'
                    },
                    languageData: {
                        'de': 'Aufrichtige Anteilnahme.',
                        'en': 'Sincere condolences'
                    },
                    maxLength: 24,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                getContentField(griefText)
            ],
            font: {
                headlineTop: {
                    family: 'MeieScript-Regular',
                    color: '#fff', 
                    size: 50,
                    TopPadding: 450,
                    lineHeight: 20
                },
                content: {
                    family: 'Roboto-Light',
                    color: '#fff', 
                    size: 18,
                    TopPadding: 500,
                    lineHeight: 20
                }
            },
            signature: {
                topPadding: 500,
                contentDep: true,
                singleSignature: false,
                fontSize: 30,
                fontSizeSub: 10,
                color: '#fff'
            }
}
